import Typography from "@egalite/ui/Typography";
import { FC, Fragment, ReactElement } from "react";

export const BenefitsCardsWrapper: FC<{ children: ReactElement | ReactElement[] }> = ({ children }) => (
	<div className="lg:hidden">{...Array.isArray(children) ? children : [children]}</div>
);

export const BenefitCard: FC<{ header: string; items: string[] }> = ({ header, items }) => (
	<div className="rounded-3xl border border-solid border-base-grey-3 bg-white my-28 py-12 px-8 w-full">
		<Typography variant="sub-headline-1" className="text-center mb-12 uppercase">
			{header}
		</Typography>
		<ul className="text-center">
			{items.map((item, idx) => (
				<Fragment key={`item-${idx}`}>
					<hr className="border-base-grey-3 border m-0 w-40 mx-auto" />
					<Typography variant="body-1" asEl="li" className="text-center !my-8">
						{item}
					</Typography>
				</Fragment>
			))}
		</ul>
	</div>
);